/* OFFFIELD — restyle the Redo (package protection) checkout button inside its shadow DOM
   to match the black OFFFIELD pill. Redo renders <redo-shopify-toggle> as a web component
   with a shadow root that theme CSS cannot reach, so we inject a <style> + force the
   green primary button to black. Idempotent + observes for re-renders. */
(function () {
  // font + footer spacing (data-target selectors are stable; obfuscated classes are not):
  //  tax->title 5px (info-card margin-top), title->subtext 2px, subtext->button 5px (info-card
  //  margin-bottom), button->continue 15px (coverage margin-bottom), continue->bottom 15px,
  //  and the price aligned to the title line (align-self:flex-start).
  var FONT = "button,p,span{font-family:'Lato',sans-serif !important;}"
    + '[data-target="info-card-container"]{margin:2px 0 8px !important;}'
    + '[data-target="text-and-buttons-container"] br{display:none !important;}'
    + '[data-target="toggle-subtext"]{display:none !important;}'
    + '[data-target="price"]{align-self:flex-start !important;line-height:16px !important;margin-top:3px !important;}'
    + '[data-target="checkout-buttons-container"]{margin:0 !important;padding:0 !important;}'
    + '[data-target="coverage-button"]{margin:0 0 15px 0 !important;}'
    + '[data-target="non-coverage-button"]{margin:0 !important;}';   /* 15px below continue comes from footer padding */
  function isGreen(bg){ return /\b19[78]\b|254,\s*136|c5fe88/i.test(bg); }

  function recolor(sr){
    sr.querySelectorAll('button').forEach(function (b) {
      if (isGreen(getComputedStyle(b).backgroundColor)) {
        b.style.setProperty('background', '#111', 'important');
        b.style.setProperty('color', '#fff', 'important');
        b.style.setProperty('border', '2px solid #111', 'important');
        b.style.setProperty('border-radius', '999px', 'important');
        b.querySelectorAll('*').forEach(function (x) { x.style.setProperty('color', '#fff', 'important'); });
      }
    });
    // secondary link: "Standard Checkout | $.." -> "CONTINUE WITHOUT FREE RETURNS | $.."
    // (all caps, bold, 1pt smaller). Re-label the prefix, keep the live price suffix.
    sr.querySelectorAll('p,span,a,button').forEach(function (e) {
      if (e.children.length) return;
      var t = e.textContent || '';
      if (/standard checkout|continue without free returns/i.test(t)) {
        // "Continue Without Free Returns | <subtotal>" — Redo's native price on this link is the
        // wrong total, so use the cart's real subtotal (the checkout-without-protection price = subtotal).
        var subEl = document.querySelector('#CartDrawer .totals .totals__total-value');
        var subM = subEl ? (subEl.textContent || '').match(/\$[\d.,]+/) : null;
        var price = subM ? subM[0] : ((t.match(/\$[\d.,]+/) || [''])[0]);
        var want = 'Continue Without Free Returns | ' + price;
        if (e.textContent !== want) e.textContent = want;
        e.style.setProperty('text-transform', 'uppercase', 'important');
        e.style.setProperty('margin', '2px 0', 'important');
        e.style.setProperty('font-weight', '700', 'important');
        e.style.setProperty('font-size', '12px', 'important');
      }
    });
    // (footer button/row spacing is handled by the injected shadow CSS above, via data-target.)
    // Redo's own shadow stylesheet gives the info-card a -15px top margin (beats our injected
    // CSS), so override it inline (inline !important wins) -> 5px gap below the tax line.
    var ic = sr.querySelector('[data-target="info-card-container"]');
    if (ic) { ic.style.setProperty('margin-top', '2px', 'important'); ic.style.setProperty('margin-bottom', '8px', 'important'); }
    // protection line copy: the "REDO CHECKOUT+" title is a text node sharing its span with
    // the (i) info-icon child, and Redo ships the whole label box visibility:hidden. Replace
    // the title text node (keep the icon), replace the subtitle, and force both visible.
    sr.querySelectorAll('span,div,p').forEach(function (e) {
      for (var i = 0; i < e.childNodes.length; i++) {
        var n = e.childNodes[i];
        if (n.nodeType === 3 && /redo\s*checkout\+/i.test(n.textContent)) {
          n.textContent = n.textContent.replace(/redo\s*checkout\+/i, 'CHECKOUT+ PACKAGE PROTECTION:');
          e.style.setProperty('visibility', 'visible', 'important');
          e.style.setProperty('font-weight', '700', 'important');
          e.style.setProperty('text-transform', 'uppercase', 'important');
          e.style.setProperty('color', '#111', 'important');
        }
      }
      if (e.children.length) return;
      var t = (e.textContent || '').trim();
      // hide the protection subtitle entirely (was "Free returns + package protection")
      if (/^free returns \+ package protection/i.test(t)) {
        e.style.setProperty('display', 'none', 'important');
      }
    });
    // primary checkout button: "[SECURE ]CHECKOUT+ $X" -> "CHECKOUT+  |  $X" (drop SECURE, add divider).
    // Target the leaf-most element holding both "checkout+" and a price (skip the secondary link).
    sr.querySelectorAll('p,span,button,div,a').forEach(function (e) {
      if (e.children.length) return;
      var t = (e.textContent || '').trim();
      if (!/checkout\+/i.test(t) || !/\$/.test(t) || /standard|continue without/i.test(t)) return;
      var m = t.match(/\$[\d.,]+/);
      if (m) { var want = 'CHECKOUT+  |  ' + m[0]; if (t !== want) e.textContent = want; }
    });
  }

  function styleToggle(host){
    if (!host.shadowRoot || host.dataset.ofhRedo) return;
    host.dataset.ofhRedo = '1';
    var sr = host.shadowRoot;
    var st = document.createElement('style');
    st.textContent = FONT;
    sr.appendChild(st);
    recolor(sr);
    try { new MutationObserver(function(){ recolor(sr); }).observe(sr, { childList:true, subtree:true, attributes:true, characterData:true }); } catch (e) {}
  }

  /* Replace the theme's remove control with a trash icon (top-right of each card).
     The icon sits inside <cart-remove-button>, so a click still triggers the
     native removal once cart-drawer.js is loaded. */
  var TRASH = '<svg class="ofh-trash-svg" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>';
  function trashIcons(){
    document.querySelectorAll('.cart-remove-block .cart-remove-button').forEach(function (b) {
      if (!b.querySelector('.ofh-trash-svg')) b.insertAdjacentHTML('beforeend', TRASH);
    });
  }

  /* Re-order each item card to match the approved design hierarchy:
       title / variant / "3 PACK" (own line) / price + strike + KNOWLEDGE (one row).
     The theme renders "3 PACK" inside the price row and KNOWLEDGE on a separate line;
     we lift the size onto its own line and pull the discount chip up beside the price. */
  function fixHierarchy(){
    document.querySelectorAll('.cart-item__details').forEach(function (d) {
      var poc = d.querySelector('.product-option-container');
      if (!poc) return;
      var box = d.querySelector('.product-option-box');   // "3 PACK"
      var disc = d.querySelector('.discounts');            // KNOWLEDGE chip
      if (box && box.parentElement === poc) d.insertBefore(box, poc);
      if (disc && disc.parentElement !== poc) poc.appendChild(disc);
      poc.classList.add('ofh-pricerow');
    });
  }

  /* Empty-cart + recommendations copy to match the approved design. */
  function fixCopy(){
    var h = document.querySelector('.cart__empty-text');
    if (h && !/nothing, yet/i.test(h.textContent)) h.textContent = 'Nothing, yet.';
    var k = document.querySelector('.button-keep-shopping');
    if (k && /keep shopping/i.test(k.textContent)) k.textContent = 'CONTINUE SHOPPING';
    var r = document.querySelector('.recommended-products-container h6');
    if (r && /miss out/i.test(r.textContent)) r.textContent = 'You Might Also Enjoy These';
    // (the "Shipping and taxes calculated at checkout" note is owned by fixFooter)
  }

  /* Subscribe control -> full-width strip flush with the card bottom. Re-render safe: enforce
     exactly ONE subscribe strip per card and drop stale duplicates, which prevents the orphaned
     "SUBSCRIBED!" strip that appeared when a re-render produced a fresh <select> while an old
     wrapped one lingered as a card child. */
  function fixSubscribe(){
    document.querySelectorAll('.cart-product-container').forEach(function (card) {
      // a re-render puts a *fresh* selling-plan <select> back inside .cart-item; prefer it.
      var freshSel = card.querySelector('.cart-item .change_selling_plan');
      var sp = freshSel || card.querySelector('.change_selling_plan');
      if (sp) {
        // SUBSCRIBED state. If a fresh select arrived, discard any stale wrap that held the old one.
        if (freshSel) card.querySelectorAll('.ofh-sub-wrap').forEach(function (w) { if (!w.contains(freshSel)) w.remove(); });
        Array.prototype.forEach.call(sp.options, function (o) { var t = o.text.replace(/^\s*subscribed!\s*/i, ''); if (t !== o.text) o.text = t; });
        var wrap = sp.closest('.ofh-sub-wrap');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'ofh-sub-wrap ofh-sub-strip';
          sp.classList.remove('ofh-sub-strip');
          card.appendChild(wrap);
          wrap.appendChild(sp);
          var lbl = document.createElement('div');
          lbl.className = 'ofh-sub-label';
          wrap.appendChild(lbl);
        }
        // remove any OTHER subscribe strip in this card (leftover "Subscribe & Save" CTA / duplicate)
        card.querySelectorAll('.ofh-sub-strip').forEach(function (s) { if (s !== wrap && !wrap.contains(s)) s.remove(); });
        if (card.lastElementChild !== wrap) card.appendChild(wrap);   // keep it the bottom strip
        var lblEl = wrap.querySelector('.ofh-sub-label');
        var st = sp.options[sp.selectedIndex] ? sp.options[sp.selectedIndex].text : '';
        var want = 'Subscribed! ' + st;
        if (lblEl && lblEl.textContent !== want) lblEl.textContent = want;
        return;
      }
      // NOT subscribed: drop any stale subscribed wrap, then move the "Subscribe & Save" CTA down.
      card.querySelectorAll('.ofh-sub-wrap').forEach(function (w) { w.remove(); });
      var ow = card.querySelector('.cart-item .option_wrapper_select');
      var btn = ow ? ow.querySelector('.btn-subscribe') : card.querySelector('.cart-item .btn-subscribe');
      var strip = (ow && btn) ? ow : (btn || null);
      if (strip && strip.parentElement !== card) { card.appendChild(strip); strip.classList.add('ofh-sub-strip'); }
      if (btn && /^subscribe & save$/i.test(btn.textContent.trim())) btn.textContent = 'Subscribe & Save an Extra 25%';
    });
  }

  /* Free-shipping progress bar: the theme tracks progress toward the higher
     "free sticker" milestone, so the bar never fills at the free-shipping mark.
     Once free shipping is achieved, fill the bar to 100%. */
  function fixShippingBar(){
    var val = document.querySelector('.cart-progress-bar-value');
    var add = document.querySelector('.add-for-free');
    if (!val || !add) return;
    var t = add.textContent || '';
    var met = !/add\s*\$?\d/i.test(t) && /free shipping/i.test(t);   // "NICE! YOU GOT FREE SHIPPING!"
    if (met && val.style.width !== '100%') val.style.setProperty('width', '100%', 'important');
  }

  /* Recommendation "+" quick-add: the subscription app injects selling-plan inputs into
     EVERY product form on the page, so the recommendation forms inherit the PDP's selected
     selling_plan and try to apply it to a different product -> 422 "Cannot apply selling
     plan to variant". The quick-add must always be one-time, so disable any selling_plan
     input on these forms (steady-state + again at submit time, before product-form reads it). */
  function fixRecForms(){
    document.querySelectorAll('.recommended-product form').forEach(function (form) {
      form.querySelectorAll('input[name="selling_plan"]').forEach(function (el) { el.disabled = true; });
      if (!form.dataset.ofhNoSp) {
        form.dataset.ofhNoSp = '1';
        form.addEventListener('submit', function () {
          form.querySelectorAll('input[name="selling_plan"]').forEach(function (el) { el.disabled = true; });
        }, true);   // capture phase: runs before product-form's submit handler serialises the form
      }
    });
  }

  /* Subtotal "was" price: show the full pre-discount/compare-at total struck through
     next to the subtotal so the savings are visible. Only shown when there ARE savings.
     cart.js has no compare_at_price, so fetch it per product once (cached). */
  var ofhCmp = {};                 // variant_id -> compare_at_price (cents)
  function getCompare(it){
    if (it.variant_id in ofhCmp) return Promise.resolve(ofhCmp[it.variant_id]);
    ofhCmp[it.variant_id] = 0;     // seed to avoid a refetch storm
    return fetch('/products/' + it.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { (p.variants || []).forEach(function (v) { ofhCmp[v.id] = v.compare_at_price || 0; }); return ofhCmp[it.variant_id] || 0; })
      .catch(function () { return 0; });
  }
  function computeSavings(totals, valEl){
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      totals.classList.add('ofh-compare-done');
      if (!cart.items || !cart.items.length) return;
      Promise.all(cart.items.map(function (it) {
        return getCompare(it).then(function (cmp) {
          var unit = (cmp && cmp > it.final_price) ? cmp : it.original_price;   // "was" = compare-at or pre-discount
          return unit * it.quantity;
        });
      })).then(function (lines) {
        var cmpTotal = lines.reduce(function (a, b) { return a + b; }, 0);
        var sub = cart.items_subtotal_price;
        var ex = totals.querySelector('.ofh-compare');
        if (cmpTotal > sub) {                                  // only when there are real savings
          var fmt = '$' + (cmpTotal / 100).toFixed(2);
          if (!ex) { ex = document.createElement('s'); ex.className = 'ofh-compare'; valEl.parentNode.insertBefore(ex, valEl); }
          if (ex.textContent !== fmt) ex.textContent = fmt;
        } else if (ex) { ex.remove(); }                        // no savings -> hide
      });
    }).catch(function () {});
  }
  var ofhLastSub = null;
  function fixSavings(){
    var totals = document.querySelector('#CartDrawer .totals');
    if (!totals) return;
    var valEl = totals.querySelector('.totals__total-value');
    if (!valEl) return;
    var cur = valEl.textContent.trim();
    if (cur === ofhLastSub && totals.classList.contains('ofh-compare-done')) return;  // already handled this render
    ofhLastSub = cur;
    computeSavings(totals, valEl);
  }

  /* Lock the header + footer (mobile): position:sticky bounces with the iOS rubber-band,
     so instead make the panel a flex column where the header and footer are fixed flex
     children and only a middle wrapper scrolls. Wrap everything between header and footer
     in an .ofh-scroll div (re-applied after cart re-renders). */
  function fixLock(){
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    var header = inner.querySelector(':scope > .drawer-header-box');
    var footer = inner.querySelector(':scope > .drawer__footer');
    if (!header || !footer) return;
    var scroll = inner.querySelector(':scope > .ofh-scroll');
    if (!scroll) { scroll = document.createElement('div'); scroll.className = 'ofh-scroll'; inner.insertBefore(scroll, footer); }
    var n = header.nextElementSibling;
    while (n && n !== footer) {
      var nx = n.nextElementSibling;
      if (n !== scroll) scroll.appendChild(n);   // move items/recommendations into the scroll region
      n = nx;
    }
  }

  /* "Shipping and taxes calculated at checkout" sits directly under the Subtotal row.
     Self-healing: a cart re-render can drop or duplicate the theme's tax note, so on every pass
     dedupe to ONE, re-create it if missing, fix the copy, and keep it pinned under the subtotal
     (the old "move it once" approach made the line vanish after adding/removing items). */
  function fixFooter(){
    var totals = document.querySelector('#CartDrawer .totals');
    if (!totals) return;
    var keep = null;
    document.querySelectorAll('#CartDrawer .tax-note').forEach(function (n) { if (!keep) keep = n; else n.remove(); });
    if (!keep) { keep = document.createElement('p'); keep.className = 'tax-note ofh-tax'; }
    if (!keep.textContent.trim() || /taxes and discount/i.test(keep.textContent)) keep.textContent = 'Shipping and taxes calculated at checkout';
    if (totals.nextElementSibling !== keep) totals.parentNode.insertBefore(keep, totals.nextSibling);
  }

  function scan(){ document.querySelectorAll('redo-shopify-toggle').forEach(styleToggle); fixLock(); trashIcons(); fixHierarchy(); fixSubscribe(); fixRecForms(); fixShippingBar(); fixSavings(); fixCopy(); fixFooter(); }

  /* Perf: the OLD observer ran scan() on EVERY document mutation (~150 per add-to-cart). We keep
     observing the document (so every cart re-render reliably re-applies the patches — scoping to
     <cart-drawer> missed multi-pass re-render settling and Redo replacing its shadow host) but
     coalesce all mutation bursts into ONE scan() per 50ms via setTimeout. setTimeout (not rAF) is
     used on purpose: rAF pauses in background/inactive tabs, which would stall the patches. This
     collapses the ~150 calls to a couple — the real cost — while staying correct. */
  var timer = null;
  function schedule(){ if (timer) return; timer = setTimeout(function(){ timer = null; scan(); ensureRedoStyled(); }, 50); }

  /* Redo hydrates/replaces its shadow root asynchronously and a shadow-root attach isn't an
     observable mutation, so poll (cheaply — just the one custom element) until every toggle is
     styled. Re-armable: a fresh poll starts whenever a new unstyled host appears (e.g. after the
     cart re-renders and Redo swaps the host). */
  var redoPolling = false;
  function pollRedo(tries){
    var hosts = document.querySelectorAll('redo-shopify-toggle');
    var allStyled = hosts.length > 0;
    hosts.forEach(function (h) { if (h.shadowRoot && !h.dataset.ofhRedo) styleToggle(h); if (!h.dataset.ofhRedo) allStyled = false; });
    if (allStyled || tries >= 60) { redoPolling = false; return; }
    redoPolling = true; setTimeout(function(){ pollRedo(tries + 1); }, 250);
  }
  function ensureRedoStyled(){ if (!redoPolling) pollRedo(0); }

  scan();
  ensureRedoStyled();
  try { new MutationObserver(schedule).observe(document.documentElement, { childList:true, subtree:true }); } catch (e) {}
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
})();
